// Images
import music_bg from "../../images/Features/feature_music_bg.jpg";
import route_bg from "../../images/Features/feature_route.jpg";
import byob from "../../images/Features/byob.jpg";

const features = [
  {
    title: "Be Your Own DJ",
    subtitle:
      "Take control of your party cruise by choosing the vibe, or allowing me to set the scene with a wide variety of music genres!",
    image: music_bg,
  },
  {
    title: "Choose Your Destinations",
    subtitle:
      "Unlike any other cruise experience, you'll have some options as to where you would like to go!",
    image: route_bg,
  },
  {
    title: "Bring Your Own Booze / Food",
    subtitle:
      "Save a fortune by bringing your own alcoholic / non-alcoholic beverages and food.  ",
    image: byob,
  },
];

export default features;
